import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/apps/vendor/layout.tsx");
